export default __webpack_public_path__ + "static/media/head01_ko_pc@2x.aef1a086.png";